import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, apiError, rinnovaAccesso } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // /auth/me usa l'access token (8h); se e' scaduto si rinnova con il refresh ("Ricordami" 90 gg)
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => rinnovaAccesso().then((r) => setUser(r.data)).catch(() => setUser(false)))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password, ricordami = false) => {
    try {
      const { data } = await api.post("/auth/login", { email, password, ricordami });
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  }, []);

  const loginVisitatore = useCallback(async () => {
    try {
      const { data } = await api.post("/auth/guest");
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    sessionStorage.removeItem("dbe_avvio");
    setUser(false);
  }, []);

  const isMaster = Boolean(user && (user.role === "MASTER" || user.role === "ADMIN"));
  const isGuest = Boolean(user && user.role === "VISITATORE");
  const can = useCallback((pagina) => Boolean(user?.pagine?.includes(pagina)), [user]);
  const puo = useCallback((funzione) => Boolean(user?.funzioni?.includes(funzione)), [user]);

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, loginVisitatore, logout,
      isMaster, isAdmin: isMaster, isGuest, can, puo }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
